module.exports = __webpack_public_path__ + "img/box-classical.b4b25d25.png";